import type {
  ExtranetHotelPack,
  ExtranetHotelPackExperiences,
} from 'app/typings/core/extranet/hotel/packs';

import styles from '../ExperienceDiscount.module.scss';

import { DiscountFields } from './DiscountFields';
import { ExperienceLabel } from './ExperienceLabel';
import { useExperienceDiscount } from './useExperienceDiscount';

type ExperienceItemProps = {
  pack: ExtranetHotelPack;
  packExperience: ExtranetHotelPackExperiences;
};

export const ExperienceItem = ({
  pack,
  packExperience,
}: ExperienceItemProps) => {
  const {
    experience,
    prices,
    discount,
    discountFieldName,
    adultDiscountedPrice,
    childDiscountedPrice,
    onAdultPriceChange,
    onChildPriceChange,
    handleDiscountBlur,
    hasError,
  } = useExperienceDiscount(pack, packExperience);

  if (!prices || adultDiscountedPrice === undefined) {
    return null;
  }

  return (
    <div className={styles.experienceItem}>
      <ExperienceLabel experience={experience} prices={prices} />

      <DiscountFields
        prices={prices}
        discount={discount}
        adultDiscountedPrice={adultDiscountedPrice}
        childDiscountedPrice={childDiscountedPrice}
        discountFieldName={discountFieldName}
        hasError={hasError}
        onAdultPriceChange={onAdultPriceChange}
        onChildPriceChange={onChildPriceChange}
        onDiscountBlur={handleDiscountBlur}
      />
    </div>
  );
};
